// src/PickupDateTime.js
import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { deDE } from '@mui/x-date-pickers/locales';
import dayjs from 'dayjs';
import 'dayjs/locale/de';

dayjs.locale('de');

export default function PickupDateTime() {
  const [pickupDateTime, setPickupDateTime] = useState(null);
  const [isPickerOpen, setPickerOpen] = useState(false); // ✅ Picker open state

  // Read initial value from HTML attributes
  useEffect(() => {
    const root = document.getElementById('pickup-root');
    if (root) {
      const dateStr = root.dataset.date;
      const timeStr = root.dataset.time;
      if (dateStr && timeStr) {
        const combined = dayjs(`${dateStr} ${timeStr}`, 'DD.MM.YYYY HH:mm');
        setPickupDateTime(combined.isValid() ? combined : null);
      }
    }
  }, []);

  useEffect(() => {
    const pickupInput = document.getElementById('pickup');
    const pickupTimeInput = document.getElementById('pickup_time');
    const pickupDropoffInput = document.getElementById('pickup_dropoff');

    if (pickupDateTime) {
      const date = pickupDateTime.format('DD.MM.YYYY');
      const time = pickupDateTime.format('HH:mm');
      document.getElementById('pickup').value = date;
      document.getElementById('pickup_time').value = time;

      const dropoff = document.getElementById('dropoff').value;
      document.getElementById('pickup_dropoff').value = `${date} to ${dropoff}`;
    } else {
      if (pickupInput) pickupInput.value = '';
      if (pickupTimeInput) pickupTimeInput.value = '';
      if (pickupDropoffInput) pickupDropoffInput.value = '';
    }
    window.__pickupDateTime__ = pickupDateTime;
  }, [pickupDateTime]);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="de"
      localeText={deDE.components.MuiLocalizationProvider.defaultProps.localeText}
    >
      <Box sx={{ width: '100%' }}>
        <DateTimePicker
          value={pickupDateTime}
          onChange={(newValue) => setPickupDateTime(newValue)}
          disablePast
          ampm={false}
          format="DD.MM.YYYY HH:mm"
          open={isPickerOpen}
          onOpen={() => setPickerOpen(true)}
          onClose={() => setPickerOpen(false)}
          slotProps={{
            textField: {
              placeholder: 'TT.MM.JJJJ hh:mm',
              fullWidth: true,
              variant: 'outlined',
              inputProps: { readOnly: false },
              onBlur: (e) => {
                const inputVal = e.target.value;
                const parsed = dayjs(inputVal, 'DD.MM.YYYY HH:mm', true);
                if (parsed.isValid()) {
                  setPickupDateTime(parsed);

                  // 🔁 Immediately update hidden inputs
                  const date = parsed.format('DD.MM.YYYY');
                  const time = parsed.format('HH:mm');
                  document.getElementById('pickup').value = date;
                  document.getElementById('pickup_time').value = time;

                  const dropoff = document.getElementById('dropoff').value;
                  document.getElementById('pickup_dropoff').value = `${date} to ${dropoff}`;
                  window.__pickupDateTime__ = parsed;
                }
              },
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
}
